export const colorMapping = {
  "update": "bg-blue-500",
  "create": "bg-green-500",
  "Yellow": "bg-yellow-500",
  "Orange": "bg-orange-500",
  "Pink": "bg-pink-500",
  "Red": "bg-red-500",
  "delete": "bg-red-500"
};
